import {ChangeDetectorRef, Component, Input} from '@angular/core';
import {Subscription} from 'rxjs';
import {TranslateService} from '@ngx-translate/core';
import { ContractAvatarsService } from '../../../contracts/services/contract-avatar.service';
import { HelpersService } from '../../../../services/helpers.service';
import { ModalService } from '../../../../services/modal/modal.service';
import { MemberModel } from '../../../../models/user.model';


@Component({
    selector: 'app-users-list',
    templateUrl: './users-list.component.html',
    styleUrls: ['./users-list.component.scss']
})
export class UsersListComponent  {
    @Input() users: MemberModel[] = [];
    private subs: Subscription = new Subscription();
    
    constructor(
        public modalService: ModalService,
        public helper: HelpersService,
        public translate: TranslateService,
        private contractAvatarsService: ContractAvatarsService,
        private cds: ChangeDetectorRef,
    ) {
    }
    ngOnDestroy(): void {
        this.subs.unsubscribe()
    }
    ngOnInit(): void {
      this.setSubscriptions()
    }
  
    setSubscriptions() {
        this.subs.add(this.contractAvatarsService.bSubAvatarsReady.asObservable().subscribe(()=>this.cds.detectChanges()))
    }


}